module.exports = __webpack_public_path__ + "assets/images/action24.131bdc296b81e22fa0901ec40c2365b4.png";